module.exports = __webpack_public_path__ + "view/2019/img/right.png";